<template>
  <RxkDialog
    v-model="showInfo"
    width="480"
    :title="title"
    :is-loading="loading"
    @sure="handleSure"
    @close="handleClose"
  >
    <div class="tw-p-[16px]">
      <el-form ref="formRef" :rules="rules" :model="formState" label-position="top">
        <el-form-item label="请填写审批意见" prop="remark">
          <RxkInput v-model="formState.remark" show-word-limit type="textarea" maxlength="1000" />
        </el-form-item>
      </el-form>
    </div>
  </RxkDialog>
</template>
<script lang="ts" setup>
import { ref, computed, reactive, watch, nextTick } from 'vue'
import { RxkDialog } from '@/components/common/RxkDialog'
import { RxkInput } from '@/components/common'
import { AuthBtn } from '@/components/business/FlowDeal/config'

const props = defineProps({
  modelValue: Boolean,
  info: Object
})
const emit = defineEmits(['update:modelValue', 'submit'])

const showInfo = computed({
  get: () => {
    return props.modelValue
  },
  set: (val: any) => {
    emit('update:modelValue', val)
  }
})

const title = computed(() => {
  return props?.info?.type === AuthBtn.REJECT ? '拒绝' : '通过'
})

const loading = ref(true)

function handleClose() {
  emit('update:modelValue', false)
}

// form相关
watch(
  () => props.modelValue,
  val => {
    if (val) {
      nextTick(() => {
        if (!formRef.value) return
        formRef.value.resetFields()
        formState.remark = `${props?.info?.type === AuthBtn.REJECT ? '不同意!' : '同意!'}`
      })
    }
  }
)
const formState = reactive({
  remark: ''
})
const formRef = ref()
const rules: any = computed(() => {
  if (props?.info?.type === AuthBtn.REJECT) {
    return {
      remark: [{ required: true, message: '请填写审批意见', trigger: 'blur' }]
    }
  }
  return {}
})

async function handleSure(fn: Fn = () => {}) {
  if (!formRef.value) return
  await formRef.value.validate(async (valid: any) => {
    if (valid) {
      emit('submit', { action: props?.info?.type, comment: formState.remark })
      handleClose()
      fn()
    } else {
      fn()
    }
  })
}
</script>
